export default class FiscalSalesVisualizerController {
  constructor() { }
}

 FiscalSalesVisualizerController.$inject = [];



// WEBPACK FOOTER //
// ./src/app/pages/fiscal-sales-visualizer/fiscal-sales-visualizer.controller.js